export default __webpack_public_path__ + "static/media/ipas-web1.2f54dbaa.jpg";